import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ lines, className = "", lineClass = "", delay = 0, inView = false, stagger = 0.12 }) => {
  const anim = { y: "0%" };
  const init = { y: "110%" };
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden">
          <motion.div
            className={`block ${lineClass}`}
            initial={init}
            {...(inView ? { whileInView: anim, viewport: { once: true } } : { animate: anim })}
            transition={{ duration: 1, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </div>
  );
};

export const SectionHead = ({ eyebrow, title, text, light = false, id }) => (
  <Reveal className="max-w-3xl" id={id}>
    <p className={`eyebrow ${light ? "text-gold" : "text-royal"}`}>{eyebrow}</p>
    <h2 className={`mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${light ? "text-white" : "text-navy"}`}>{title}</h2>
    {text && <p className={`mt-5 text-base leading-relaxed ${light ? "text-white/70" : "text-slate-600"}`}>{text}</p>}
  </Reveal>
);
